import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BasicDetailsState, EducationalDetailsState, ProfessionalDetailsState } from './student-registration.state';

export const StudentRegistrationActions = createActionGroup({
    source: 'Student Registration',
    events: {
        // Basic Details Actions
        'Update Basic Details': props<{ basicDetails: Partial<BasicDetailsState> }>(),
        'Set Basic Details': props<{ basicDetails: BasicDetailsState }>(),
        'Clear Basic Details': emptyProps(),

        // Educational Details Actions
        'Update Educational Details': props<{ educationalDetails: Partial<EducationalDetailsState> }>(),
        'Set Educational Details': props<{ educationalDetails: EducationalDetailsState }>(),
        'Clear Educational Details': emptyProps(),

        // Professional Details Actions
        'Update Professional Details': props<{ professionalDetails: Partial<ProfessionalDetailsState> }>(),
        'Set Professional Details': props<{ professionalDetails: ProfessionalDetailsState }>(),
        'Clear Professional Details': emptyProps(),

        // Step Navigation Actions
        'Set Current Step': props<{ step: number }>(),
        'Add Completed Step': props<{ step: number }>(),
        'Remove Completed Step': props<{ step: number }>(),
        'Clear Completed Steps': emptyProps(),

        // Form Submission Actions
        'Set Submitted': props<{ isSubmitted: boolean }>(),
        'Submit Application': emptyProps(),
        'Submit Application Success': props<{ response: any }>(),
        'Submit Application Failure': props<{ error: string }>(),

        // Loading and Error Actions
        'Set Loading': props<{ isLoading: boolean }>(),
        'Set Error': props<{ error: string | null }>(),
        'Clear Error': emptyProps(),

        // Reset Actions
        'Reset State': emptyProps(),
        'Reset Form Data': emptyProps(),
        'Cancel Registration': emptyProps(),

        // Persistence Actions
        'Load From Storage': emptyProps(),
        'Save To Storage': emptyProps(),
        'Load From Storage Success': props<{ state: any }>(),
        'Load From Storage Failure': props<{ error: string }>(),

        // Initial Data Loading Actions
        'Load Initial Data': props<{ courseId: string }>(),
        'Load Initial Data Success': props<{ data: any }>(),
        'Load Initial Data Failure': props<{ error: string }>(),
    },
});
